import React from 'react';
import ErrorLayout from '../../components/ErrorLayout';

const BadRequest = () => (
  <ErrorLayout 
    code={400} 
    title="Bad Request" 
    message="The server could not understand your request. Please check your input and try again." 
    icon="pi pi-times-circle" 
    color="#e74c3c" 
  />
);
export default BadRequest;